// extracted by mini-css-extract-plugin
module.exports = {"deck":"playerDeck_deck__35PjM","ia_deck":"playerDeck_ia_deck__2JYdM"};